import en from './locales/en.json';
import ru from './locales/ru.json';

export const resources = {
  en: { translation: en },
  ru: { translation: ru },
} as const;

export type Locale = keyof typeof resources;

/** English is the primary language; device language is applied when supported. */
export const defaultLocale: Locale = 'en';
export const supportedLocales: Locale[] = ['en', 'ru'];

export function resolveLocale(deviceLang?: string | null): Locale {
  const code = (deviceLang ?? '').slice(0, 2).toLowerCase();
  return (supportedLocales as string[]).includes(code) ? (code as Locale) : defaultLocale;
}

export { en, ru };
